import { useRouter } from 'next/router'
import { useAuth } from '../providers/AuthProvider'
import routes from '../config/routes'
import { useEffect } from 'react'

export default function onlyGuest(WrappedComponent: any) {
  // eslint-disable-next-line react/display-name
  return () => {
    const { isLoggedIn } = useAuth()
    const router = useRouter()
    const redirect = router.query.redirect as string

    useEffect(() => {
      if (!isLoggedIn) return

      if (redirect) {
        void router.replace(redirect)
      } else {
        void router.replace(routes.index)
      }
    }, [isLoggedIn, redirect, router])

    if (isLoggedIn) {
      return null
    }

    return <WrappedComponent />
  }
}
